/**
 * Format BR RFQ address on three lines:
 *   Line 1 — street address
 *   Line 2 — country, state
 *   Line 3 — city-pincode
 */
export function formatBusinessRelocationFullAddress({
  address,
  country,
  state,
  city,
  pincode,
}) {
  const street = String(address ?? '').trim();
  const countryLabel = String(country ?? '').trim();
  const stateLabel = String(state ?? '').trim();
  const cityLabel = String(city ?? '').trim();
  const pin = String(pincode ?? '').trim();

  const isMissing = (value) => !value || value === '—';

  const lines = [];

  if (street) lines.push(street);

  const countryState = [
    !isMissing(countryLabel) ? countryLabel : '',
    !isMissing(stateLabel) ? stateLabel : '',
  ]
    .filter(Boolean)
    .join(', ');
  if (countryState) lines.push(countryState);

  let cityPin = '';
  if (!isMissing(cityLabel)) {
    cityPin = pin ? `${cityLabel}-${pin}` : cityLabel;
  } else if (pin) {
    cityPin = pin;
  }
  if (cityPin) lines.push(cityPin);

  return lines.length ? lines.join('\n') : '';
}
